import React from "react";
// Customizable Area Start
import PaymentActivitiesController, { Props } from "./PaymentActivitiesController.web";
import NavigationMenu from "../../navigationmenu/src/NavigationMenu.web";
import { Box, CircularProgress, IconButton, Typography } from "@material-ui/core";
import RightSideBar from "../../activityfeed/src/RightSideBar.web";
import { backArrowDark, backArrowWhite } from "../../groups/src/assets";
import { BarChart } from "../../../components/src/BarChart.web";
// Customizable Area End

export default class PaymentActivities extends PaymentActivitiesController {
    constructor(props: Props) {
        super(props);
        // Customizable Area Start
        // Customizable Area End
    }
    // Customizable Area Start

    // Customizable Area End

    render() {
        // Customizable Area Start
        const { checked, navigation } = this.props
        return (
            <NavigationMenu id="" tabItem="Earnings" checked={checked} navigation={navigation}>
                <Box style={webStyles.screenContainer}>
                    <Box style={webStyles.innerContainer}>
                        <Box style={webStyles.haedingContainer}>
                            <IconButton onClick={this.navigateToEarnigs} data-test-id="back-btn">
                                <img src={checked ? backArrowDark : backArrowWhite} style={{ width: '24px', height: '24px' }} />
                            </IconButton>
                            <Typography style={{ ...webStyles.headingText, color: checked ? '#222222' : '#fff' }}>Payment Activities</Typography>
                        </Box>

                        {this.state.loading ? (
                            <Box style={{ display: 'flex', alignItems: 'center', flex: 'auto', justifyContent: 'center' }}>
                                <CircularProgress color="primary" />
                            </Box>
                        ) : (
                            <>
                                <Box style={webStyles.card}>
                                    <Typography style={webStyles.cardText}>Total Annual Revenue</Typography>
                                    <Typography style={webStyles.amoutText}>$ {parseFloat(this.state.totalAnnualRevenue.toString()).toFixed(2)}</Typography>
                                </Box>

                                <Box style={{ paddingLeft: '10px' }}>
                                    <BarChart 
                                        chartOptions={this.state.chartOptions} 
                                        series={this.state.series} 
                                        headingStyle={{ marginBottom: '21px' }}
                                        title="Monthly Referral Revenue"
                                        checked={checked}
                                    />
                                </Box>
                            </>
                        )}
                    </Box>

                    <RightSideBar checked={checked} navigation={navigation} />
                </Box>
            </NavigationMenu>
        );
        // Customizable Area End
    }
}

// Customizable Area Start
const webStyles = {
    screenContainer: {
        display: "flex",
        width: "100%",
    },
    innerContainer: {
        display: "flex",
        width: '60%',
        padding: '24px',
        flexDirection: "column",
        "@media (max-width:1000px)": {
            width: "80%",
        },
    } as React.CSSProperties,
    haedingContainer: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'row',
    } as React.CSSProperties,
    headingText: {
        fontWeight: 800,
        fontSize: '18px',
        lineHeight: '24px',
        fontFamily: 'Manrope',
    },
    card: {
        display: 'flex',
        flexDirection: 'column',
        padding: '20px',
        borderRadius: '10px',
        background: "linear-gradient(357.07deg, #3858E3 -51.03%, #BA05F7 138.78%)",
        marginBottom: '22px',
        marginTop: '23px',
    } as React.CSSProperties,
    cardText: {
        fontSize: '18px',
        lineHeight: '24px',
        fontWeight: 800,
        fontFamily: 'Manrope',
        color: '#fff',
        marginBottom: '15px',
    },
    amoutText: {
        fontSize: '24px',
        lineHeight: '27px',
        fontWeight: 800,
        fontFamily: 'Manrope',
        color: '#fff',

    },
}

// Customizable Area End
